// extracted by mini-css-extract-plugin
export default {"fullWidth":"to-z","image":"uo-z","lazyLoadPicture":"vo-z","lazyLoadSpinner":"wo-z","lazyLoadSpin":"xo-z","lazyLoadImage":"yo-z","hasStyledAspectRatio":"zo-z"};